import { stat } from 'fs';

const getters = {
  accessToken: state => state.user.accessToken,
  // refreshToken: state => state.user.refreshToken,
  name: state => state.user.name,
  roleIds: state => state.user.roleIds,
  loginId: state => state.user.loginId,
  accountId: state => state.user.accountId,
  isOnDemandSettlementFile: state => state.user.isOnDemandSettlementFile,
  isCusEnabled: state => state.user.isCusEnabled,
  cusLabelId: state => state.user.cusLabelId,
  cusLabelName: state => state.user.cusLabelName,
  upiEnableDynamicQR: state => state.user.upiEnableDynamicQR,
  upiEnablePaymentLinks: state => state.user.upiEnablePaymentLinks,
  upiEnableStaticLink: state => state.user.upiEnableStaticLink,
  passExpDays: state => state.user.passExpDays,
  enableAutocomplete: state => state.user.enableAutocomplete,
  isCollectAmount: state => state.user.isCollectAmount,
  isLoading: state => state.user.isLoading,
  activeModelCode: state => state.user.activeModelCode,
  refCount: state => state.user.refCount,
  defaultMonth: state => state.user.defaultMonth,
  policy: state => state.user.policy,
  disableMonths: state => state.user.disableMonths,
  accountNames: state => state.user.accountNames,
  accountIndex: state => state.user.accountIndex,
  csrfToken: state => state.user.csrfToken,
  settlementTypeId: state => state.user.settlementTypeId,
  productList: state => state.user.productList,
  marketApi: state => state.user.marketApi,
  ccmsType: state => state.user.ccmsType,
  upiEnableBulkPaymentLinks: state => state.user.upiEnableBulkPaymentLinks,
  tfaEnableLogin: state => state.user.tfaEnableLogin,
};
export default getters;
